<template>
    <div class="wb-navbar">
        <div class="wb-navbar-buttons-grid">
            <NavbarCircleButton
                @click="newProject"
                :tooltip="'Новый проект'">
                <template #svg>
                    <SVGNewDoc/>
                </template>
            </NavbarCircleButton>
            <div class="wb-navbar-buttons-grid-separator"></div>
            <NavbarCircleButton :class="{'pressed': storeUI.mode===1}"
                                v-on:click="storeUI.switchMode()"
                                :tooltip="'Параметры комнаты'">
                <template #svg>
                    <SVGFrame/>
                </template>
            </NavbarCircleButton>
            <NavbarCircleButtonColor :method="() => openOverlay('wall')"
                                     :is-pressed="isOverlayWall"
                                     :tooltip="'Цвет стен'"
                                     :preview-prop="wallColor.priview"
                                     :name-prop="wallColor.name">
                <template #svg>
                    <SVGColorWall/>
                </template>
            </NavbarCircleButtonColor>
            <NavbarCircleButtonColor :method="() => openOverlay('floor')"
                                     :is-pressed="isOverlayFloor"
                                     :tooltip="'Цвет пола'"
                                     :preview-prop="floorColor.priview"
                                     :name-prop="floorColor.name">
                <template #svg>
                    <SVGColorFloor/>
                </template>
            </NavbarCircleButtonColor>
            <div class="wb-navbar-buttons-grid-separator"></div>
            <NavbarCircleButton :class="{'pressed': storeUI.isRuler}"
                                v-on:click="storeUI.switchIsRuler()"
                                :tooltip="'Показать размеры'">
                <template #svg>
                  <div>
                    <SVGRuler/>
                  </div>
                </template>
            </NavbarCircleButton>
            <NavbarCircleButton :class="{'pressed': storeUI.isDecoration}"
                                v-on:click="storeUI.switchIsDecoration()"
                                :tooltip="'Добавить предметы интерьера'">
                <template #svg>
                  <div>
                    <SVGTshirt/>
                  </div>
                </template>
            </NavbarCircleButton>
            <NavbarCircleButtonColor :method="() => openOverlay('element')"
                                     :preview-prop="configurationStore.getWardrobeBaseColor"
                                     :tooltip="'Цвет системы'"
                                     :name-prop="configurationStore.getWardrobeBaseColorName">
                <template #svg>
                    <SVGColorItem/>
                </template>
            </NavbarCircleButtonColor>
            <NavbarCircleButton :disabled="!data.uuid"
                                v-on:click="deleteEl()"
                                :tooltip="'Удалить'">
                <template #svg>
                    <div>
                        <SVGDelete/>
                    </div>
                </template>
            </NavbarCircleButton>
        </div>

        <NavbarProjectName/>

        <div class="wb-navbar-spacer"></div>

        <div class="wb-navbar-buttons-grid">
            <NavbarCircleButton @click="saveProject"
                                :tooltip="'Сохранить проект'">
                <template #svg>
                    <SVGSave/>
                </template>
            </NavbarCircleButton>
            <NavbarCircleButton @click="saveProjectAsCopy"
                                :tooltip="'Сохранить проект как копию'">
                <template #svg>
                    <SVGSaveAsCopy/>
                </template>
            </NavbarCircleButton>
            <NavbarCircleButton @click="isVisibleModal"
                                :tooltip="'Сделать снимок'">
                <template #svg>
                    <SVGPhoto/>
                </template>
            </NavbarCircleButton>
            <NavbarCircleButton @click="() => {restoreFromHistory(-1)}"
                                :tooltip="'Отменить действие'">
                <template #svg>
                    <SVGUndo/>
                </template>
            </NavbarCircleButton>
            <NavbarCircleButton @click="() => {restoreFromHistory(1)}"
                                :tooltip="'Повторить действие'">
                <template #svg>
                    <SVGRedo/>
                </template>
            </NavbarCircleButton>
        </div>

        <NavbarProjectPrice :is-list-opened="isResultSidebar"
                            :value-prop="storeData.getCost"
                            :method="() => openResultSidebar()"/>

        <NavbarGreenButton :disabled="!this.storeData.zeroPrice" :text="'Заказать'" @click="order"/>
    </div>
</template>

<script>
import NavbarCircleButton from '@/UI/Components/ComponentsNavbar/NavbarCircleButton.vue';
import SVGNewDoc from '@/UI/Components/SVG/SVGNewDoc.vue';
import SVGFrame from '@/UI/Components/SVG/SVGFrame.vue';
import SVGColorWall from '@/UI/Components/SVG/SVGColorWall.vue';
import SVGColorFloor from '@/UI/Components/SVG/SVGColorFloor.vue';
import SVGRuler from '@/UI/Components/SVG/SVGRuler.vue';
import SVGTshirt from '@/UI/Components/SVG/SVGTshirt.vue';
import SVGSave from '@/UI/Components/SVG/SVGSave.vue';
import SVGUndo from '@/UI/Components/SVG/SVGUndo.vue';
import SVGRedo from '@/UI/Components/SVG/SVGRedo.vue';
import SVGPhoto from '@/UI/Components/SVG/SVGPhoto.vue';
import NavbarProjectName from '@/UI/Components/ComponentsNavbar/NavbarProjectName.vue';
import NavbarProjectPrice from '@/UI/Components/ComponentsNavbar/NavbarProjectPrice.vue';
import NavbarGreenButton from '@/UI/Components/ComponentsNavbar/NavbarGreenButton.vue';
import NavbarCircleButtonColor from '@/UI/Components/ComponentsNavbar/NavbarCircleButtonColor.vue';
import { restoreFromHistory, useConfigurationStore } from '@/Store/storeConfiguration';
import { useUIOnlyStore } from '@/Store/storeUI';
import { useStoreData } from '@/Store/storeData';
import { takeScreenshot } from '@/lib/takeScreenshot';
import OverlayScreen from '@/UI/Components/ComponentsOverlay/OverlayScreen.vue';
import { newProject, order, saveProject } from '@/utils/postmessages';
import SVGColorItem from '@/UI/Components/SVG/SVGColorItem.vue';
import SVGDelete from '@/UI/Components/SVG/SVGDelete.vue';
import { deleteEl } from '@/lib/deleteEl';
import SVGSaveAsCopy from '@/UI/Components/SVG/SVGSaveAsCopy.vue';

export default {
    name: 'TheNavbar',
    components: {
        SVGSaveAsCopy,
        SVGDelete,
        SVGColorItem,
        OverlayScreen,
        NavbarCircleButtonColor,
        NavbarGreenButton,
        NavbarProjectPrice,
        NavbarProjectName,
        SVGPhoto,
        SVGRedo,
        SVGUndo,
        SVGSave,
        SVGTshirt,
        SVGRuler,
        SVGColorFloor,
        SVGColorWall,
        SVGFrame,
        SVGNewDoc,
        NavbarCircleButton,
    },
    setup() {
        const configurationStore = useConfigurationStore();
        const storeUI = useUIOnlyStore();
        const storeData = useStoreData();
        return {
            configurationStore,
            storeUI,
            storeData,
        };
    },
    methods: {
        restoreFromHistory,
        takeScreenshot,
        undo() {
            console.log('undo');
        },
        isVisibleModal() {
            takeScreenshot();
            this.$emit('is-visible-modal');
        },
        saveProject() {
            saveProject();
        },
        saveProjectAsCopy() {
          saveProject('As');
        },
        newProject() {
            newProject();
        },
        order() {
            order();
        },
        deleteEl,
    },
    computed: {
        floorColor() {
            let selectedColor = this.configurationStore.getRoomParamByName('selectedFloorColor');
            if(selectedColor) {
                return this.storeData.getDecorById(selectedColor);
            }
            return {};
        },
        wallColor() {
            let selectedColor = this.configurationStore.getRoomParamByName('selectedWallColor');
            if(selectedColor) {
                return this.storeData.getDecorById(selectedColor);
            }
            return {};
        },
        data() {
            return this.storeUI.getSelectedSceneObject;
        },
    },
    props: [
        'openOverlay',
        'openResultSidebar',
        'isResultSidebar',
        'isScreenVisible',
        'isOverlayFloor',
        'isOverlayWall',
    ],
};
</script>

<style scoped lang="scss">
@import "CSS/colors.scss";
.pressed{
  color: $green1;
  background-color: $white;
}

.wb-navbar {
    height: 64px;
    width: 100%;
    z-index: 20;
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 16px;
    box-sizing: border-box;

    background-color: $gray1;
}

.wb-navbar-buttons-grid {
    display: grid;
    grid-auto-flow: column dense;
    grid-column-gap: 16px;
}

.wb-navbar-buttons-grid-separator {
    background-color: $gray3;
    width: 1px;
    height: 100%;
    box-sizing: border-box;
    user-select: none;
}

.wb-navbar-spacer {
    display: flex;
    width: 100%;

}
</style>
